export default {
  sunday: 'sunday',
  monday: 'monday',
};
